export type IAnimationDirection = 'up' | 'down' | 'left' | 'right';

const OFFSET_ANIMATION = 25;

export const setAnimationFrom = (
  direction: IAnimationDirection,
  offset = OFFSET_ANIMATION
) => {
  const from = () =>
    ({
      up: { y: -offset },
      down: { y: offset },
      left: { x: -offset },
      right: { x: offset },
    })[direction];

  const to = () => {
    if (direction === 'up' || direction === 'down') return { y: 0 };

    if (direction === 'left' || direction === 'right') return { x: 0 };
  };

  return {
    from,
    to,
  };
};
